import axios from "axios";
import store from "../../store/index";


const typedStore = store;
const client = typedStore.state.infoVideos;

const rmAxiosInstance = axios.create({
  baseURL: 'https:' + window.process?.env.URL_LIVE_INTRANET === window.location.hostname ? "//" + window.location.URL_LIVE_INTRANET : window.process.env.API_PLAYER + "/api",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: `Bearer ${window.process.env.API_TOKEN}`,
  },
});
rmAxiosInstance.interceptors.request.use(
  function (config) {
    if (config.headers != undefined) {
      config.headers['client-name'] = client?.videoInfos?.client;
    }
    return config;
  },

  function (error) {
    return Promise.reject(error);
  }
);

rmAxiosInstance.interceptors.response.use(
  function (response) {

    return response;
  },
  function (error) {
    switch (error.response?.status) {
      case 401:
        break;
      default:
        break;
    }
    return Promise.reject(error);
  }
);
export default rmAxiosInstance;

